import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import articles from '../data/articles.json';
import Meta from '../model/Meta';

class Blog extends Component {

	componentDidMount() {
			$('html, body').animate({scrollTop: 0}, 300);
	}

	render() {

		let all = articles.articles;
		const meta = {
			title: "Blog - Contracts.ph",
			description: "Read how to create custom legal forms for FREE"
		}

		return(
			<div className="page page-inner not-found blog">
							
				<Meta {...meta} />

				<div className="container-fluid">
					<div className="container p-0">
						<h1 className="page-title">Blog Articles</h1>
						<div className="page-content">
							<div className="card-deck">
								{
									all.map((obj, i)=>{
										return (
											<div className="card" key={i}>
												<div className="img-holder" style={{'background': 'url('+obj.image+') top center no-repeat', 'backgroundSize': 'cover'}}></div>
												<div className="card-body">
													<h4 className="card-title">
														{/* blog auto url, replace space with hyphen via regex then lowercase */}
														<Link to={"/blog/"+obj.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase()}>{obj.title}</Link>
													</h4>
													<p className="card-text"><small className="text-mute">{obj.author}</small></p>
													{/* Max 220 chars, then remove html strings via regex */}
													<p className="card-text">{obj.content.substring(0, 220).replace(/<[^>]+>/g, '')} [...]</p>
												</div>
												<div className="card-footer">
													<Link to={"/blog/"+obj.title.replace(/[\W_]/g, " ").replace(/\s+/g, '-').toLowerCase()} className="btn btn-default">Read more ...</Link>
												</div>
											</div>
										)
									})
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Blog;


// WEBPACK FOOTER //
// ./src/pages/Blog.js